import moment from 'moment'
import {
  CAMPAIGN_INTERNAL_STATUSES,
  CAMPAIGN_ENUM_TYPES,
} from '../../../../shared/constants'

export const getCampaignStartDate = campaign => {
  if (!campaign) return null
  if (campaign.isSelfServe) {
    return campaign.startDate || null
  } else {
    return (
      campaign.startDate ||
      (campaign.activeDates.start &&
        moment(campaign.activeDates.start).format('YYYY-MM-DD')) ||
      null
    )
  }
}

export const shouldDisplayEndDate = campaign => {
  if (campaign.isSelfServe) {
    const lastMissionDate = getLastMissionDate(campaign)
    if (
      campaign.selfServeData[0].internalStatus ===
      CAMPAIGN_INTERNAL_STATUSES.DRAFT
    ) {
      return false
    } else if (!campaign.noExpiration || !!lastMissionDate) {
      return true
    } else if (campaign.noExpiration) {
      return false
    }
  } else {
    if (campaign.noExpiration) {
      return false
    } else {
      return true
    }
  }
}

export const getLastMissionDate = campaign => {
  if (!campaign.lastMissionDate) return null
  return moment(
    campaign.lastMissionDate.split('T')[0],
    'YYYY-MM-DD',
    true,
  ).format('YYYY-MM-DD')
}

export const getLastStepReached = (lastActiveStep, type) => {
  const isDM = type === CAMPAIGN_ENUM_TYPES.DIRECTMAIL
  switch (lastActiveStep) {
    case 'audience':
    case 'segments':
      return 'design'
    case 'design':
      return 'details'
    case 'details':
      return 'submit'
    case 'submit':
      return 'submit'
    case 'home':
      return isDM ? 'segments' : 'audience'
    default:
      return 'audience'
  }
}
